import { DTO__generation } from '@shared/dto/generation/DTO__generation';
import { DTO__user_task } from '@shared/dto/user_task/DTO__user_task';
import { STATE__generation } from '../STATE__generation';

export function FN_GENERATION__update_locally(state: STATE__generation, generation: DTO__generation): void {
  state.generations_map.set(generation._id, generation);

  //need refresh map to trigger re-render
  state.generations_map = new Map(state.generations_map);

  if (state.generation_current._id == generation._id) state.generation_current = generation.clone();

  let user_task = state.user_tasks_map.get(generation.user_task_id);

  if (user_task) {
    upsert_generation_on_user_task(generation, user_task);

    state.user_tasks_map.set(generation.user_task_id, user_task);

    //need to force rerender
    state.user_tasks_map = new Map(state.user_tasks_map);
  }

  let { user_task_current } = state;

  if (user_task_current._id == generation.user_task_id) {
    upsert_generation_on_user_task(generation, user_task_current);

    //need recreate to force rerender
    state.user_task_current = new DTO__user_task().clone(user_task_current);
  }
}

const upsert_generation_on_user_task = (generation: DTO__generation, user_task: DTO__user_task) => {
  let index = user_task.generations.findIndex(item => item._id == generation._id);

  if (index == -1) {
    user_task.generations = [...user_task.generations, generation];
  } else {
    user_task.generations[index] = generation;
  }
};
